import * as bootbox from "bootbox";
import Seed from "DMS/Seed/All";
export default function SendRequest(pId, pPHPFile) {
    var SendStr = "";
    var and = "";
    var size = pId.length;
    for (var i = 0; i < size; i++) {
        var ELT = Seed.Tab.GetFrame().find('#' + pId[i]);
        if (ELT.val() === "") {
            bootbox.alert(MSG_REQUIRED_FIELD_HOTLINE);
            return false;
        }
        var data = encodeURIComponent(ELT.val());
        SendStr += and + pId[i] + "=" + data;
        and = "&";
    }
    Seed.Ajax.Post({
        url: pPHPFile,
        data: SendStr,
        async: true,
        success: function (xml) {
            Seed.Tab.GetFrame().append(xml);
        }
    });
}
//# sourceMappingURL=ePortail_rom.custom.js.map